<template lang="html">
  <div class="pb-4">
    <ValidationProvider rules="required" name="Title" v-slot="{ errors, valid }">
      <b-field
        :type="{ 'is-danger': errors[0], 'is-success': valid && displaySuccess }"
        :message="errors"
      >
        <template slot="label">
          Title*
          <b-tooltip position="is-right" type="is-dark">
            <template v-slot:content>
              <span>Title of the {{ itemType }}</span>
            </template>
            <b-icon type="is-gray" size="is-small" icon="help-circle-outline"></b-icon>
          </b-tooltip>
        </template>

        <b-input
          v-if="itemType == 'project'"
          placeholder="e.g. Miku on Christmas"
          v-model="localTitle"
          maxlength="50"
          expanded
          @input="updateTitle"
        />

        <b-input
          v-else-if="itemType == 'craft'"
          placeholder="e.g. Sword of the warrior"
          v-model="localTitle"
          maxlength="50"
          expanded
          @input="updateTitle"
        />

        <b-input
          v-else-if="itemType == 'article'"
          placeholder="e.g. How to take nice pictures"
          v-model="localTitle"
          maxlength="50"
          expanded
          @input="updateTitle"
        />

        <b-input
          v-else-if="itemType == 'purchase'"
          placeholder="e.g. Blue lenses"
          v-model="localTitle"
          maxlength="50"
          expanded
          @input="updateTitle"
        />

        <b-input
          v-else
          v-model="localTitle"
          maxlength="50"
          expanded
          @input="updateTitle"
        />
      </b-field>
    </ValidationProvider>
  </div>
</template>

<script>
import { ValidationProvider } from 'vee-validate'
// Mixins
import { textMixin } from '@/mixins/textMixin'

export default {
  mixins: [textMixin],
  props: ['title', 'itemType', 'displaySuccess'],
  data () {
    return {
      localTitle: null
    }
  },
  components: {
    ValidationProvider
  },
  created () {
    this.localTitle = this.title
  },
  methods: {
    updateTitle (value) {
      this.$emit('updateTitle', value)
    }
  }
}
</script>

<style lang="scss" scoped></style>
